var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoFalsePromise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 0H8C3.58172 0 0 3.58172 0 8V68C0 72.4183 3.58172 76 8 76H68C72.4183 76 76 72.4183 76 68V8C76 3.58172 72.4183 0 68 0Z",
    fill: "#FCEBE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_246)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5003,
    cy: 39.2324,
    r: 14.6429,
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 59C48.8145 59 58 49.8137 58 38.5C58 27.1855 48.8137 18 37.5 18C26.1855 18 17 27.1863 17 38.5C17 49.8145 26.1863 59 37.5 59ZM45.1277 45.174C46.7067 45.174 47.9882 43.8925 47.9882 42.3135C47.9882 40.7345 46.7067 39.453 45.1277 39.453C43.5487 39.453 42.2672 40.7345 42.2672 42.3135C42.2672 43.8925 43.5487 45.174 45.1277 45.174ZM29.8714 45.174C31.4504 45.174 32.732 43.8925 32.732 42.3135C32.732 40.7345 31.4504 39.453 29.8714 39.453C28.2924 39.453 27.0109 40.7345 27.0109 42.3135C27.0109 43.8925 28.2924 45.174 29.8714 45.174ZM46.2695 30.0117C44.2671 27.3498 41.0822 25.6269 37.4992 25.6269C33.9162 25.6269 30.7312 27.3489 28.7289 30.0117C28.2557 30.6426 28.3815 31.5408 29.0133 32.0156C29.6442 32.4889 30.5424 32.363 31.0156 31.7312C32.4958 29.7616 34.8504 28.4874 37.4992 28.4874C40.148 28.4874 42.5034 29.7616 43.9827 31.7312C44.4559 32.3622 45.3541 32.488 45.9851 32.0156C46.6168 31.5408 46.7419 30.6426 46.2695 30.0117Z",
    fill: "#F78670"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(17 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFalsePromise);
export default __webpack_public_path__ + "static/media/NoFalsePromise.928c6a603f7e4509313ae21e9beec11a.svg";
export { ForwardRef as ReactComponent };